
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'
import { TProject } from './project'
import { TUser } from './user'

type TableRelationListRequestType = TableListRequestType & {
  type: string, // 'user' or 'project'
  id: string    // the user or project id
}

export type TUserProjectRelatioon = {
  _id: string,
  user: TUser,
  project: TProject,
  permissions: {
    read: { type: Boolean, default: true },
    write: { type: Boolean, default: true },
    delete: { type: Boolean, default: false },
  },
  createdAt: Date,
  uodatedAt: Date,
}

export default class UserProjectRelatioon implements ITableListModel<TUserProjectRelatioon> {
  constructor() {
  }

  public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, type, id, page = 0, limit = 10, q = '' }: TableRelationListRequestType) {
    let query = `type=${type}&id=${id}&page=${page}&limit=${limit}`
    if (q) query += '&q=' + encodeURI(q)
    if (mode == TABLE_REQUEST_MODE.POSITION) {
      query += '&mode=position'
    }
    return await getData(`/user-project-relation?${query}`)
  }

  public async read(id: string) {
    return await getData(`/user-project-relation/${id}`)
  }

  public async create(data: any) {
    return await postData('/user-project-relation', data)
  }

  public async update(id: string, data: any) {
    return await patchData(`/user-project-relation/${id}`, data)
  }

  public async delete(id: string) {
    return await deleteData(`/user-project-relation/${id}`)
  }

  public async count() {
    return await countData(`/user-project-relation/count`)
  }
}